export default{
    cadastra:{
        method:'post',
        url:'aplicativo/cadastro'
    },
    delete:{
        method:'delete',
        url:'trabalhador/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'trabalhador/lista'
    },
    editar:{
        method:'get',
        url:'trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'trabalhador/update'
    },
    busca:{
        method:'get',
        url:'aplicativo/busca{/id}'
    },
    eventolista:{
        method:'get',
        url:'trabalhador/evento/2200/lista{/id}'
    },
    eventocadastra:{
        method:'put',
        url:'evento/update'
    },
    eventodeleteesocial:{
        method:'delete',
        url:'trabalhador/evento/deletar{/id}'
    },
    eventodelete:{
        method:'delete',
        url:'evento/deletar{/id}'
    },
    documento:{
        method:'get',
        url:'documentos/trabalhador/lista?id={id}'
    },
    matricula:{
        method:'get',
        url:'trabalhador/matricula'
    },
    
}
